import { Route, Routes } from "react-router-dom";
import AllUsers from "../pages/dashboardPage/userSettings/allUsers/AllUsers";
import UserImages from "../pages/dashboardPage/userSettings/userImages/UserImages";
import SearchForUser from "../pages/dashboardPage/userSettings/searchForUser/SearchForUser";

const UserNavigator = () => {
  return (
    <Routes>
      <Route path="/show-all-users" element={<AllUsers />} />
      <Route path="/edit-users-images" element={<UserImages />} />
      <Route path="/search-one-user" element={<SearchForUser />} />
      <Route path="*" element={<AllUsers />} />
    </Routes>
  );
};

export default UserNavigator;
